import Link from "next/link"
import cx from "classnames"
import { getBackToProductsAnalytics } from "@/components/RegisterOfflineProduct/v1/RegisterOfflineHelper"
import arrowBack from "@/public/icons/back-arrow.svg"
import { sanitizeInnerHtml } from "@/utils/helper"
import StepNavigator from "@/components/core/StepNavigator/StepNavigator"
import RegisterProductConfirmation from "@/components/RegisterOfflineProduct/v1/RegisterProductConfirmation"
import styles from "@/components/RegisterOfflineProduct/v1/RegisterOfflineProductView/index.module.scss"

const RegisterOfflineProductView = ({
  staticText = {},
  steps = [],
  isSuccess = false,
  myProductsPath = "",
  productDetails = [],
  customerDetails = [],
}) => {
  return (
    <div className={`${styles.registerOfflineProductViewWrapper}`}>
      <div className="register-offline-product">
        <div
          className={cx({
            "register-offline-product__go-back-main": true,
            "register-offline-product__go-back-main-confirmation": isSuccess,
          })}
        >
          <div className="container kf-react-container">
            <div className="row mx-0 px-0">
              <div className="col-12 px-0">
                <div className="register-offline-product__go-back ">
                  <Link
                    href={myProductsPath}
                    className="arrow-back gbh-data-layer"
                    data-gbh-data-layer={getBackToProductsAnalytics(
                      isSuccess,
                      myProductsPath
                    )}
                  >
                    <img src={arrowBack?.src} alt="" />
                    <span className="link">
                      {sanitizeInnerHtml(staticText.backToMyProducts)}
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {isSuccess ? (
          <RegisterProductConfirmation
            staticText={staticText}
            myProductsPath={myProductsPath}
            customerDetails={customerDetails}
            productDetails={productDetails}
          />
        ) : (
          <div className="container kf-react-container">
            <div className="row mx-0 px-0">
              <div className="col-12 px-0">
                <div className="register-offline-product__main-container">
                  <div className="register-offline-product__main-header-top">
                    <h1 className="main-title">
                      {staticText.registerProductsTitle}
                    </h1>
                  </div>
                  <StepNavigator data={steps} />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default RegisterOfflineProductView
